exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "app-message p{transition:all 1s linear;position:relative;display:block;padding:1.5em 3em 1.5em 5em;color:#fff;text-align:center;font-size:.8em;background-color:#000;opacity:1}app-message p.animate-show-hide.ng-hide{opacity:0}app-message p.animate-show-hide.ng-hide-add,app-message p.animate-show-hide.ng-hide-remove{transition:all .5s linear}app-message p.info{background-color:#ffde00}app-message p.success{background-color:#079201}app-message p.success:before{content:\"\\E66E\"!important}app-message p.error{background-color:#bd3632}app-message p.error:before{content:\"\\E602\"!important}app-message p:before{content:\"\";font-family:icon-Renault-Global;speak:none;left:10%}app-message p:before,app-message p a{font-size:1.3em;position:absolute;top:1.1em}app-message p a{color:#fff!important;right:5%;text-decoration:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/common/app-message/app-message.styl
// module id = 576
// module chunks = 0